// Close the mobile menu after a tap on a link.
document.querySelectorAll('.menu .sheet a').forEach(a => a.addEventListener('click', () => { const d = a.closest('details'); if (d) d.open = false; }));
